import React from "react";
import "../style.css";

const MarqueeSection = () => {
  return (
    <div className="marquee-footer-container">
      <div className="marquee-svg-background">
        <div className="marquee-u-marquee marquee-app-footer__marquee">
          <div className="marquee-noise"></div>

          <div className="marquee-u-marquee__content">
            Premium Shopify Sections <span className="marquee-divider">#</span> Free.
          </div>
          <div aria-hidden="true" className="marquee-u-marquee__content">
            Custom Design <span className="marquee-divider">&</span> No Developers.
          </div>
          <span className="marquee-divider">-</span>
          <div aria-hidden="true" className="marquee-u-marquee__content">
            Start Building <span className="marquee-divider">-</span> Today.
          </div>
        </div>
      </div>
      <div className="marquee-grid">
        <div className="marquee-grid-lines"></div>
        <div className="marquee-grid-lines"></div>
        <div className="marquee-grid-lines"></div>
        <div className="marquee-grid-lines"></div>
      </div>
    </div>
  );
};

export default MarqueeSection;
